import { all, fork } from "redux-saga/effects";

import { ticketRatingSagas } from "./ticket-rating/sagas";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* noAuthSagas() {
  yield all([fork(ticketRatingSagas)]);
}
